export default __webpack_public_path__ + "static/media/Odometer.eed601ee.svg";